<cll-dialog-layout>
    <cll-dialog-header>
        <cll-dialog-title>Add Priority</cll-dialog-title>
        <cll-dialog-subtitle>For {{ data.name }}</cll-dialog-subtitle>
    </cll-dialog-header>
    <div class="dialog-detail">
        <div class="tabs-table-container priority-table-height">
            <table class="cll-table priority-table-borders">
                <thead>
                <tr>
                    <th>Priorities</th>
                    <th>Delay (in minutes)</th>
                    <th>Description</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let priority of data.priorities; let i = index">

                    <td>{{ priority.name }}</td>
                    <td>{{ priority.delay }}</td>
                    <td>{{ priority.description }}</td>
                </tr>
                </tbody>
            </table>
        </div>
        <span>Add new priority level:</span>
        <div class="grid-columns-2">
            <cll-form-field label="Priority name">
                <input cllFormInput [formControl]="priorityFormGroup.controls.name" type="text">
            </cll-form-field>
            <cll-form-field label="Delay (in minutes)">
                <input cllFormInput
                       [formControl]="priorityFormGroup.controls.delay"
                       type="number"
                       min="0"
                       max="10080"
                >
                <cll-number-control
                    cllFormFieldControl
                />
            </cll-form-field>
        </div>
        <cll-form-field label="Description">
            <textarea cllFormInput [formControl]="priorityFormGroup.controls.description" type="text"></textarea>
        </cll-form-field>
    </div>
    <span class="dialog-divider"></span>
    <cll-dialog-footer>

        @if (addPriorityRequest.error(); as error) {
            <app-error-panel [error]="error" />
        }

        <button cll-button
                colour="variant"
                cllDialogClose>
            Cancel
        </button>
        <button cll-filled-button
                colour="secondary"
                [disabled]="priorityFormGroup.invalid || this.addPriorityRequest.loading()"
                (click)="add()">
            Create
        </button>
    </cll-dialog-footer>
</cll-dialog-layout>
